import { RecentlyViewed } from './recently-viewed-products.js';

document.addEventListener('DOMContentLoaded', async () => {
  const grid = document.getElementById('recently-viewed-grid');
  if (!grid) return;

  const handles = RecentlyViewed.getProducts();
  if (!handles.length) return;

  const currentHandle = window.location.pathname.split('/').pop();
//   const products = handles.filter(h => h !== currentHandle);

const limit = parseInt(grid.dataset.limit) || 6;
let products = handles.filter(h => h !== currentHandle);
products = products.slice(0, limit);


  if (!products.length) return;

  for (const handle of products) {
    try {
      const res = await fetch(`/products/${handle}.js`);
      if (!res.ok) continue;

      const product = await res.json();

      const image =
        product.featured_image ||
        (product.images.length ? product.images[0] : '');

      const price = (product.price / 100).toFixed(2);

      const item = document.createElement('div');
      item.className = 'recently-viewed__item';

      item.innerHTML = `
        <a href="${product.url}" class="recently-viewed__link">
          ${image ? `<img src="${image}" alt="${product.title}">` : ''}
          <p>${product.title}</p>
          <p>₹${price}</p>
        </a>
      `;

      grid.appendChild(item);
    } catch (err) {
      console.error('Recently viewed error:', err);
    }
  }
});